import { Injectable } from '@angular/core';
export var ProgressbarConfig = (function () {
    function ProgressbarConfig() {
        /** if `true` changing value of progress bar will be animated (note: not supported by Bootstrap 4) */
        this.animate = true;
        /** maximum total value of progress element */
        this.max = 100;
    }
    ProgressbarConfig.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ProgressbarConfig.ctorParameters = function () { return []; };
    return ProgressbarConfig;
}());
//# sourceMappingURL=progressbar.config.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/ng2-bootstrap/progressbar/progressbar.config.js
// module id = ../../../../ng2-bootstrap/progressbar/progressbar.config.js
// module chunks = 4